import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef } from "react";
import { Wallet, setTopupDialog } from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { showNotification } from "../../../../../app/slices/notificationSlice";
import { NumericFormat } from "react-number-format";
import { HiOutlineBanknotes, HiOutlinePlusCircle } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const TopupForm = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user.form);
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody,
  );
  const { control, handleSubmit } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.to_user_id = user.id;
    if (props.userData.is_representative) {
      dispatch(Wallet.topupRep(data, transactionsSearchBody)).then((x) => {
        dispatch(setTopupDialog());
      });
    } else
      dispatch(
        showNotification({
          message: "هذه العملية مخصصة للمندوب فقط",
          type: "error",
        }),
      );
  };

  const handlDialog = () => {
    dispatch(setTopupDialog());
  };

  const NumericFormatCustom = forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;
      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
        />
      );
    },
  );

  return (
    <FormDialog
      open={_Wallet.topUpDialog}
      onClose={handlDialog}
      icon={<HiOutlinePlusCircle />}
      title={"اضافة رصيد للمندوب"}
      subtitle="أدخل المبلغ الكلي والمبلغ المدفوع لإضافة الرصيد"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات الرصيد">
        <Grid item xs={12} sm={6}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ الكلي"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="cash"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ المدفوع"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default TopupForm;
